export default __webpack_public_path__ + "static/media/new-hospital.acca595c.png";